import { GiftOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import { theme } from '../../theme/theme';

export const NewReleaseNotificationContainer = styled.div`
	position: fixed;
	inset-block-end: ${theme.margins.lg};
	inset-inline-end: ${theme.margins.lg};
	z-index: ${theme.zIndex.feedbackButton};
	display: flex;
	align-items: center;
	gap: ${theme.paddings.sm};
	max-inline-size: 420px;
	padding-block: ${theme.paddings.sm};
	padding-inline: ${theme.paddings.base};
	background-color: ${theme.colors.white};
	border-radius: ${theme.border.radii.lg};
	box-shadow: ${theme.boxShadows.dropdown};

	&[data-compact='true'] {
		inset-block-end: ${theme.margins.xs};
		inset-inline-end: ${theme.margins.xs};
		gap: ${theme.paddings.xs};
		padding-block: ${theme.paddings.xs};
		padding-inline: ${theme.paddings.sm};
	}
`;

export const NewReleaseNotificationIcon = styled(GiftOutlined)`
	font-size: ${theme.font.sizes.lg};
	color: ${theme.font.colors.primary};
`;

export const NewReleaseNotificationText = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

export const NewReleaseNotificationTitle = styled.span`
	font-size: ${theme.font.sizes.base};
	font-weight: ${theme.font.weights.semibold};
	color: ${theme.font.colors.base};
`;

export const NewReleaseNotificationDescription = styled.span`
	font-size: ${theme.font.sizes.sm};
	color: ${theme.font.colors.secondary};
`;
